import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormError from './FormError';
import InputField from './InputField';
import SelectField from './SelectField';
import states from '../helpers/states';
import CheckboxField from './CheckboxField';

let UpdatePaymentProfileForm = ({
  paymentMethods = [],
  isDefault,
  handleSubmit,
  error,
  successMsg,
}) => {
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Field
          component={SelectField}
          name="card_id"
          label="Card"
          options={paymentMethods.map((method) => [
            method.id,
            `**** **** **** ${method.card_last_four} ${method.expiration_month}/${method.expiration_year}`,
          ])}
        />
        <Field component={InputField} name="card_number" label="Card number" />
        <Field
          component={InputField}
          name="expiration_month"
          label="Expiration month"
        />
        <Field
          component={InputField}
          name="expiration_year"
          label="Expiration year"
        />
        <Field component={InputField} name="cvc" label="CVC" />
        <Field component={InputField} name="first_name" label="First name" />
        <Field component={InputField} name="last_name" label="Last name" />
        <Field component={InputField} name="address" label="Address" />
        <Field component={InputField} name="city" label="City" />
        <Field
          component={SelectField}
          name="state"
          label="State"
          empty="Choose a state"
          options={states.map((state) => [state.abbreviation, state.name])}
        />
        <Field component={InputField} name="zip_code" label="ZIP" />
        {!isDefault && (
          <Field
            component={CheckboxField}
            name="is_default"
            label="Is default"
          />
        )}
        {error && <FormError error={error} />}
        {successMsg && <p className="text-success">{successMsg}</p>}
        <button className="btn btn-primary">Update payment method</button>
      </form>
    </div>
  );
};

const validate = (values) => {
  let errors = {};

  if (!values.default_card_id) {
    errors.default_card_id = 'Required';
  }

  return errors;
};

UpdatePaymentProfileForm = reduxForm({
  form: 'updatePaymentProfile',
  enableReinitialize: true,
  validate,
})(UpdatePaymentProfileForm);

export default UpdatePaymentProfileForm;
